import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Lock" }), /* @__PURE__ */ _jsx("path", {
		d: "M19.8333 11.6667V9.33333C19.8333 6.11167 17.2216 3.5 14 3.5C10.7783 3.5 8.16663 6.11167 8.16663 9.33333V11.6667M14 16.9167V19.25M10.2666 24.5H17.7333C19.6935 24.5 20.6736 24.5 21.4223 24.1185C22.0808 23.783 22.6163 23.2475 22.9518 22.589C23.3333 21.8403 23.3333 20.8602 23.3333 18.9V17.2667C23.3333 15.3065 23.3333 14.3264 22.9518 13.5777C22.6163 12.9191 22.0808 12.3837 21.4223 12.0481C20.6736 11.6667 19.6935 11.6667 17.7333 11.6667H10.2666C8.30644 11.6667 7.32635 11.6667 6.57766 12.0481C5.91909 12.3837 5.38366 12.9191 5.0481 13.5777C4.66663 14.3264 4.66663 15.3065 4.66663 17.2667V18.9C4.66663 20.8602 4.66663 21.8403 5.0481 22.589C5.38366 23.2475 5.91909 23.783 6.57766 24.1185C7.32635 24.5 8.30644 24.5 10.2666 24.5Z",
		stroke: "#344054",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgLock;
